import { DocumentData, QueryDocumentSnapshot } from "@firebase/firestore";
import { FirebaseConverter } from "../../../firebase/firebaseConverter";
import { ClimbingEventSimplifiedResults, UserSumOfPoints } from "../../../models/ClimbingEventSimplifiedResults";

export class EventSimplifiedResultConverter extends FirebaseConverter<ClimbingEventSimplifiedResults>{

    fromFirestore(snapshot: QueryDocumentSnapshot<DocumentData>): ClimbingEventSimplifiedResults {
        const simplifiedResults = snapshot.data() as ClimbingEventSimplifiedResults

        simplifiedResults.userSumOfPoints = new Map<string, UserSumOfPoints>(Object.entries(simplifiedResults.userSumOfPoints as any))

        return simplifiedResults;

    }
}